import { axios } from 'Services/AjaxService';
import { getStaticCompletions } from './staticCompletionTerms';

export const updateSearchCompletionTerms = async (context, { url }) => {
  const { searchTerm: search, submitting } = context.state;

  if (!submitting) {
    try {
      const response = await axios.get(url, {
        params: { search }
      });

      if (response.data) {
        context.commit('SET_COMPLETION_TERMS', response.data.completions);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Axios request error:', error);
    }
  }
};

export const updateStaticSearchCompletionTerms = async (context) => {
  const salesChannelId = context.rootState.core.salesChannel.salesChannelId;
  const completions = getStaticCompletions(salesChannelId);
  context.commit('SET_COMPLETION_TERMS', completions);
};
